import {NgModule} from '@angular/core';
import {SharedModule} from "../../shared/shared.module";
import {ShelterOverviewComponent} from "./shelter-overview/shelter-overview.component";
import {AnimalSheltersRepository} from "../../shared/states/animal-shelter.repository";

@NgModule({
  declarations: [
    ShelterOverviewComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [AnimalSheltersRepository],
  exports: []
})
export class AnimalShelterModule {
}
